const formatDate = (date) => {
  if (date) {
    return new Date(date).toISOString().split("T")[0];
  } else {
    return null;
  }
};

module.exports = formatDate